module.exports = __webpack_public_path__ + "img/teutons-DE.efa7c791.png";